
import {getProductByID, toAwning, toBlind } from '../shop-front-component/ProductCollection'

import GenericProductPage from './GenericProductPage'

export default function ProtectaDeepChannelPage() {

  return (
      GenericProductPage(getProductByID(49),toAwning)
  )
}
